import React, { useState, useEffect } from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import { getText } from '../../libs/utils';
import { OrderCanceled, OrderWarned, OrderErrorII, OrderWarnedII } from '../../assets/images/icons';
import { styled, useTheme } from '@mui/material/styles';
import OrderFeedback from './OrderFeedback';
import { JivoChatButton } from '../../JivoChat';

const OrderData = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  alignItems: 'start',
  margin: '30px 0 0',
  width: '100%',
  flexWrap: 'wrap',
  ":empty": {
    display: 'none'
  },
  [theme.breakpoints.down('lg')]: {
    alignItems: 'center'
  },
  [theme.breakpoints.only('xs')]: {
    margin: '20px 0 0',
    " > .MuiButton-root": {
      width: '100%',
    }
  }
}))

const MyGreyLink = styled(Box)(({ theme }) => ({
  margin: '13px 0 0 20px',
  width: '100%',
  [theme.breakpoints.only('md')]: {
    width: 'auto',
    marginTop: 0
  },
  [theme.breakpoints.only('sm')]: {
    width: 'auto',
    marginTop: 0
  },
  [theme.breakpoints.only('xs')]: {
    width: '100%',
    textAlign: 'center',
    margin: '7px 0 0'
  }
}))

const GreyBox = styled(Box)(({ theme }) => ({
  background: 'rgba(169, 169, 169, 0.05)',
  borderRadius: '11px',
  height: '100%',
  justifyContent: 'center',
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  minHeight: '300px',
  flex: 1,
  marginTop: '30px',
}));

const OrderError = ({ order, getStatus }) => {
  const theme = useTheme();
  let isMDnDown = useMediaQuery(theme.breakpoints.down('lg'));

  const textAlias = {
    2: getText("orderErrorNeedFixHint"),
    4: getText("orderErrorHint4"),
    5: getText("orderErrorHint5"),
    8: getText("orderErrorHint8"),
    10: getText("orderErrorHint10"),
  }

  const needFixOrderDataState = [2].includes(order.paymentStatus.id);
  const isUserCancelled = [4, 5].includes(order.paymentStatus.id);

  return (
    <Box sx={order.toPaymentSystemType?.value == 'EXTERNAL' ? { display: 'flex', flexDirection: 'column', justifyContent: 'start', height: '100%' } : {}}>

      <Typography variant="h3">{needFixOrderDataState ? getText('tooltipTitleWanr') : getText('orderRefused')}</Typography>
      <Typography variant="regularCaption">{textAlias[order.paymentStatus.id]}</Typography>

      {isMDnDown && <Box sx={{ display: 'flex', marginTop: '30px' }}>
        <Box sx={{ pt: '2px' }}>
          {needFixOrderDataState ? <OrderWarned /> : <OrderCanceled />}
        </Box>
        <Box sx={{ padding: '0 0 0 16px' }}>
          <Typography fontWeight={600} color={needFixOrderDataState ? "primary.warning" : 'primary.darkRed'}>
            {order.description || order.paymentStatus.statuses[order.paymentStatus.id]}
          </Typography>
          <Typography variant='greyCaption'>{getText('orderErrorReasonCaption')}</Typography>
        </Box>
      </Box>}

      <OrderData>
        <JivoChatButton variant="contained" sx={{ padding: '15px 31px' }}>{getText('stteBlockChatBtn')}</JivoChatButton>

        {!isMDnDown && <Box sx={{ display: 'flex', padding: '0 0 0 25px', flex: 1 }}>
          <Box>{needFixOrderDataState ? <OrderWarned /> : <OrderCanceled />}</Box>
          <Box sx={{ padding: '0 0 0 16px' }}>
            <Typography fontWeight={600} color={needFixOrderDataState ? "primary.warning" : 'primary.darkRed'}>
              {order.description || order.paymentStatus.statuses[order.paymentStatus.id]}
            </Typography>
            <Typography variant='greyCaption'>{getText('orderErrorReasonCaption')}</Typography>
          </Box>
        </Box>}

        {!isUserCancelled && <MyGreyLink>
          <Typography variant="linkGrey"><Link to="/">{getText('stteBlockMainBtn')}</Link></Typography>
        </MyGreyLink>}
      </OrderData>

      {!isUserCancelled && <GreyBox>
        {needFixOrderDataState ? <>
          <OrderWarnedII />
          <Typography sx={{ display: 'block', color: 'primary.warning', fontSize: '12px', marginTop: '20px' }}>{getText('tooltipTitleWanr')}</Typography>
        </> : <>
          <OrderErrorII />
          <Typography sx={{ display: 'block', color: 'primary.darkRed', fontSize: '12px', marginTop: '20px' }}>{getText('orderRefused')}</Typography>
        </>}
      </GreyBox>}
      {isUserCancelled && <OrderFeedback clientComment={order.clientComment} orderCode={order.code} updateCallback={getStatus} />}
    </Box>
  )
}

export default OrderError
